module.exports = __webpack_public_path__ + "static/img/hysteroscope-4.0f1b70f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/hysteroscopepic/hysteroscope-4.jpg
// module id = Ce24
// module chunks = 52